export enum InputModifier {
    Ctrl = 'Ctrl',
    Shift = 'Shift',
    Alt = 'Alt',
    Meta = 'Meta'
}
